import { sortBy } from '@sorare/core/src/lib/arrays';

export const sortRewards = (summary: Record<string, number>) =>
  sortBy(
    r => r.probability,
    Object.entries(summary).map(([name, probability]) => ({
      name,
      probability,
    }))
  );
